import '@main';

await u.domready();

const {
  createApp,
  ref,
  onMounted,
  watch,
} = Vue;

const vueFormSlider = VueformSlider;

const RangeInputApp = {
  props: {
    name: String,
    min: Number,
    max: Number,
    step: Number,
    merge: Number,
    prefix: String,
    minVal: Number,
    maxVal: Number,
  },
  name: 'RangeInputApp',
  components: {
    vueFormSlider
  },
  setup(props: any) {
    const value = ref([0, 0]);
    const minVal = ref(props.minVal);
    const maxVal = ref(props.maxVal);

    onMounted(() => {
      value.value[0] = props.minVal;
      value.value[1] = props.maxVal;

      minVal.value = props.minVal;
      maxVal.value = props.maxVal;
    });

    watch(() => value.value, (value) => {
      minVal.value = value[0];
      maxVal.value = value[1];
    });

    return {
      value,
      minVal,
      maxVal,
    };
  }
};

u.directive(
  'range-input',
  {
    mounted(el) {
      u.module(el, 'range.button', async () => {
        const options = JSON.parse(el.dataset.options!);

        const app = createApp(RangeInputApp, options);

        app.mount(el);
      });
    }
  }
);
